import { useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { ArrangementsGrid } from "./ArrangementsGrid.js";
import { ExportPanel } from "./ExportPanel.js";
import { FunctionsPanel } from "./FunctionsPanel.js";
import { ImportTab } from "./ImportTab.js";
import { ReadinessDashboard } from "./ReadinessDashboard.js";
import type { JSX } from "react";

type TabId = "import" | "grid" | "functions" | "readiness" | "export";

export function RegisterWorkspace(): JSX.Element {
  const { registerId } = useParams<{ registerId: string }>();
  const [tab, setTab] = useState<TabId>("import");
  const [hasData, setHasData] = useState(false);

  if (registerId === undefined) {
    return <Navigate to="/" replace />;
  }

  return (
    <div data-testid="register-workspace">
      <div className="tab-bar">
        <button
          className={`tab${tab === "import" ? " active" : ""}`}
          data-testid="tab-import"
          onClick={() => setTab("import")}
        >
          1 · Import
        </button>
        <button
          className={`tab${tab === "grid" ? " active" : ""}`}
          data-testid="tab-grid"
          onClick={() => setTab("grid")}
        >
          2 · Grid
        </button>
        <button
          className={`tab${tab === "functions" ? " active" : ""}${!hasData ? " tab-locked" : ""}`}
          data-testid="tab-functions"
          onClick={() => {
            if (hasData) setTab("functions");
          }}
          title={!hasData ? "Import and promote data first" : undefined}
          style={!hasData ? { opacity: 0.45, cursor: "not-allowed" } : undefined}
        >
          3 · Functions
        </button>
        <button
          className={`tab${tab === "readiness" ? " active" : ""}${!hasData ? " tab-locked" : ""}`}
          data-testid="tab-readiness"
          onClick={() => {
            if (hasData) setTab("readiness");
          }}
          title={!hasData ? "Import and promote data first" : undefined}
          style={!hasData ? { opacity: 0.45, cursor: "not-allowed" } : undefined}
        >
          4 · Readiness
        </button>
        <button
          className={`tab${tab === "export" ? " active" : ""}${!hasData ? " tab-locked" : ""}`}
          data-testid="tab-export"
          onClick={() => {
            if (hasData) setTab("export");
          }}
          title={!hasData ? "Import and promote data first" : undefined}
          style={!hasData ? { opacity: 0.45, cursor: "not-allowed" } : undefined}
        >
          5 · Export
        </button>
      </div>

      {tab === "import" && (
        <ImportTab registerId={registerId} onDataLoaded={() => setHasData(true)} />
      )}
      {tab === "grid" && <ArrangementsGrid registerId={registerId} />}
      {tab === "functions" && <FunctionsPanel registerId={registerId} hasData={hasData} />}
      {tab === "readiness" && <ReadinessDashboard registerId={registerId} hasData={hasData} />}
      {tab === "export" && <ExportPanel registerId={registerId} hasData={hasData} />}
    </div>
  );
}
